import actions from './index'
import { lang } from '../../utils/withLang'
import { ENDPOINTS, ENTITY_MESSAGE_EVENTS, MODAL_MESSAGES_EVENTS_MANAGE, } from '../../config/constants'
import { customFormUpdate } from './coreActions'
import axios from 'axios'
import { disassembleResults, setUrlParams } from '../../utils/functions'
import { generatePath } from 'react-router-dom'
import selectors from '../selectors'
import actionTypes from '../action-types'
import { storeEntities } from './resourceActions'
import { toast } from 'react-toastify'

/***********************
 * REQUESTS
 */

export const requestRead = options => (
  axios.get(setUrlParams(ENDPOINTS.MESSAGES_EVENTS, options)).then(
    response => response.data)
)

export const requestCreate = messagesEvent => (
  axios.post(ENDPOINTS.MESSAGES_EVENTS, { ...messagesEvent }).then(
    response => response.data)
)

export const requestUpdate = messagesEvent => (
  axios.patch(
    generatePath(ENDPOINTS.MESSAGES_EVENT, { id: messagesEvent.id }),
    { ...messagesEvent },
  )
)

export const requestDelete = id => (
  axios.delete(generatePath(ENDPOINTS.MESSAGES_EVENT, { id }))
)

/***********************
 CRUD
 **********************/

/** READ */

export const crudRead = (options = {}) => (dispatch, getState) => {

  dispatch(crudReadPending())

  return requestRead(options).then(response => {
    dispatch(crudReadSucceeded(response))
    return response.data
  })
}

export const crudReadPending = () => ({
  type: actionTypes.messagesEvents.CRUD_READ_PENDING,
})

export const crudReadSucceeded = data => dispatch => {
  const results = disassembleResults(data, ENTITY_MESSAGE_EVENTS)
  dispatch(storeEntities(results.entities))
  dispatch({
    type: actionTypes.messagesEvents.CRUD_READ_SUCCEEDED,
    payload: results,
  })
}

/** READ */

/** CREATE */
export const crudCreate = messagesEvent => dispatch => (
  requestCreate(messagesEvent).then(
    ({ data: createdMessagesEvent }) => {
      toast.success(lang.successfully_created)
      dispatch(crudCreateSucceeded(createdMessagesEvent))
      dispatch(crudRead())
      return createdMessagesEvent
    })
)

export const crudCreateSucceeded = result => ({
  type: actionTypes.messagesEvents.CRUD_UPDATE_SUCCEEDED,
  payload: { ...result },
})/** CREATE */

/** UPDATE */
export const crudUpdate = messagesEvent => dispatch => (
  requestUpdate(messagesEvent).then(response => {
    toast.success(lang.successfully_updated)
    dispatch(crudUpdateSucceeded(response.data))
    dispatch(crudRead())
    return response.data
  })
)

export const crudUpdateSucceeded = messagesEvent => ({
  type: actionTypes.messagesEvents.CRUD_UPDATE_SUCCEEDED,
  payload: { ...messagesEvent },
})/** UPDATE */

/** DELETE */

export const crudDelete = messagesEvent => dispatch => {
  return (
    requestDelete(
      typeof messagesEvent === 'object' ? messagesEvent.id : messagesEvent).then(() => {
      toast.success(lang.successfully_deleted)
      dispatch(crudDeleteSucceeded())
      dispatch(crudRead())
    })
  )
}

export const crudDeleteSucceeded = () => ({
  type: actionTypes.messagesEvents.CRUD_DELETE_SUCCEEDED,
})

/** DELETE */

/***********************
 MANAGE
 **********************/

export const openModalForm = (messagesEventId = null) => (
  dispatch, getState) => {
  if (messagesEventId) {
    const messagesEvent = selectors.messagesEvents.getById(getState(),
      messagesEventId)
    dispatch(customFormUpdate('forms.messagesEvent', messagesEvent, true))
  }
  dispatch(actions.core.openModalForm({
    title: lang[!messagesEventId ? 'new_message_event' : 'edit_message_event'],
    component: MODAL_MESSAGES_EVENTS_MANAGE,
    form: 'messagesEvent',
    isNew: !messagesEventId,
  }))
}